<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="black">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <vue-element-loading :active="appLoading" :is-full-screen="true" background-color="#FFFFFF" color="#42275a"
      spinner="spinner" />
    <v-layout class="mainfont" wrap justify-center pb-7>
      <v-flex xs11 pt-4>
        <v-layout wrap>
          <v-flex xs12>
            <v-card class="pb-4">
              <v-layout wrap justify-start>
                <v-flex xs12 pl-3 pt-3 pb-4 class="bgcustom">
                  <span style="font-size: 25px; color: white">Application Number - {{ list.applicationNo }}</span>
                </v-flex>
                <v-flex xs12>
                  <v-layout wrap pb-3>
                    <v-flex xs12>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-flex>


                <v-flex lg12 px-5>
                  <v-layout wrap justify-center>


                    <v-flex xs5 lg3 text-left>
                      <span class="subheading" style="font-size: 16px;">
                        Applicant Name
                      </span>
                      <br />
                      <span>{{ list.applicantName }}</span>
                    </v-flex>
                    <v-flex xs5 lg3 text-left>
                      <span class="subheading" style="font-size: 16px;">
                        District
                      </span>
                      <br />
                      <span>{{ list.applicantDistrict }}</span>
                    </v-flex>

                    <v-flex xs5 lg3 text-left>
                      <span class="subheading" style="font-size: 16px;">
                        Email

                      </span>
                      <br />
                      <span>{{ list.applicantEmail }}</span>
                    </v-flex>
                    <v-flex xs5 lg3 text-left>
                      <span class="subheading" style="font-size: 16px;">
                        Mobile Number

                      </span>
                      <br />
                      <span>{{ list.applicantMobileNo }}</span>
                    </v-flex>
                    <v-flex xs5 lg3 text-left pt-4>
                      <span class="subheading" style="font-size: 16px;">
                        Address 1

                      </span>
                      <br />
                      <span>{{ list.applicantAddress1 }}</span>
                    </v-flex>
                    <v-flex xs5 lg3 text-left pt-4>
                      <span class="subheading" style="font-size: 16px;">
                        Address 2

                      </span>
                      <br />
                      <span>{{ list.applicantAddress2 }}</span>
                    </v-flex>
                    <v-flex xs5 lg3 text-left pt-4>
                      <span class="subheading" style="font-size: 16px;">
                        Pincode

                      </span>
                      <br />
                      <span>{{ list.applicantPinCode }}</span>
                    </v-flex>
                    <v-flex xs5 lg3 text-left pt-4>
                      <span class="subheading" style="font-size: 16px;">
                        Id Type
                      </span>
                      <br />
                      <span>{{ list.idType }}</span>
                    </v-flex>

                    <v-flex xs5 lg3 text-left pt-4>
                      <span class="subheading" style="font-size: 16px;">
                        Depot Name

                      </span>
                      <br />
                      <span>{{ list.depotName }}</span>
                    </v-flex>

                    <v-flex xs5 lg3 text-left pt-4>
                      <span class="subheading" style="font-size: 16px;">
                        Depot Address

                      </span>
                      <br />
                      <span>{{ list.depotAddress }}</span>
                    </v-flex>

                    <v-flex xs5 lg3 text-left pt-4>
                      <span class="subheading" style="font-size: 16px;">
                        Timber Qantity

                      </span>
                      <br />
                      <span>{{ list.timberQuantity }}</span>
                    </v-flex>

                    <v-flex xs5 lg3 text-left pt-4>
                      <span class="subheading" style="font-size: 16px;">
                        Id Type
                      </span>
                      <br />
                      <span>{{ list.idType }}</span>
                    </v-flex>

                    <v-flex xs5 lg3 text-left pt-4>
                      <span class="subheading" style="font-size: 16px;">
                        Id Card No
                      </span>
                      <br />
                      <span>{{ list.idcardNo }}</span>
                    </v-flex>

                    <v-flex xs5 lg3 text-left pt-4>
                      <span class="subheading" style="font-size: 16px;">
                        Need Passbook

                      </span>
                      <br />
                      <span>{{ list.needPassBook ? "Yes" : "No" }}</span>
                    </v-flex>


                    <v-flex xs5 lg3 text-left pt-4>
                  <span class="subheading" style="font-size: 16px">
                    Id Proof</span>
                    <br />

                  <v-btn small class="bgcustom" dark  :href="mediaURL + list.identityCard" target="_blank"><span
                      style="
                        text-transform: none;
                        font-family: mainfont;
                        font-size: 12px;
                      ">View
                    </span></v-btn>
                  <br />
                </v-flex>

                <v-flex xs5 lg3 text-left pt-4>
                  <span class="subheading" style="font-size: 16px">
                    ownershipCertificate </span>
                    <br />

                  <v-btn small class="bgcustom" dark  :href="mediaURL + list.ownershipCertificate" target="_blank"><span
                      style="
                        text-transform: none;
                        font-family: mainfont;
                        font-size: 12px;
                      ">View
                    </span></v-btn>
                  <br />
                </v-flex>

                <v-flex xs12 lg3 text-left pt-4>
  <span class="subheading" style="font-size: 16px">Property Mark Impressions</span>
  <br />

  <!-- Loop through each property mark impression -->
  <v-flex xs12 lg12 pt-3 pl-3>
    <v-layout row wrap>
      <v-flex v-for="(impression, index) in list.propertyMarkImpressions" :key="index" xs12 lg12 pb-2>
        <v-btn small class="bgcustom" dark :href="mediaURL + impression" target="_blank">
          <span style="text-transform: none; font-family: mainfont; font-size: 12px;">Impression {{ index + 1 }}</span>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-flex>
  <br />
</v-flex>

<v-flex xs12 lg9 text-left pt-4>
  <span class="subheading" style="font-size: 16px">Progress</span>
  <br />

  <!-- Loop through each property mark impression -->
  <v-flex xs12 lg4 pt-3 pl-3>
    <v-layout row wrap>
      <v-flex xs6 lg4>
        <v-btn small class="bgcustom" dark @click="$router.push('/records?id=' + id)">
          <span style="text-transform: none; font-family: mainfont; font-size: 12px;">Progress</span>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-flex>
  <br />
</v-flex>

<v-flex lg3 class="text-start">
  </v-flex>

  <v-flex lg3 class="text-start">
    </v-flex>

    <v-flex lg3 class="text-start">
      </v-flex>

                  </v-layout>


                </v-flex>
                <v-flex xs5 lg3 text-left pt-4 v-if="list.animalinvolved === 'YES'">
                  <span class="subheading" style="font-size: 16px;">
                    Preshoot Order
                  </span>&nbsp;

                  <v-btn class="bgcustom" dark download :href="baseURL + 'file/get/' + Preshootfile"
                    target="_blank"><span style="text-transform: none; font-family: mainfont; font-size: 12px;">View
                    </span></v-btn>
                  <br />
                </v-flex>
                <v-flex xs5 lg3 text-left pl-0 pl-lg-3 pt-4 v-if="list.animalinvolved === 'YES'">
                  <span class="subheading" style="font-size: 16px;">
                    Species Name

                  </span>
                  <br />
                  <span>{{ list.species }}</span>
                </v-flex>
                <v-flex xs5 lg3 text-left pt-4 v-if="list.animalinvolved === 'YES'">
                  <span class="subheading" style="font-size: 16px;">
                    No Of Animals

                  </span>
                  <br />
                  <span>{{ list.noOfAnimal }}</span>
                </v-flex>
                <v-flex xs5 lg3 text-left pt-4 v-if="list.animalinvolved === 'YES'">
                  <span class="subheading" style="font-size: 16px;">
                    Preshoot Number
                  </span>
                  <br />
                  <span>{{ list.preshootNumber }}</span>
                </v-flex>
                <v-flex xs5 lg3 text-left pt-4 v-if="list.animalinvolved === 'YES'">
                  <span class="subheading" style="font-size: 16px;">
                    Preshoot Valid From
                  </span>
                  <br />
                  <span>{{ formatDate(list.validityfromDate) }}</span>
                </v-flex>
                <v-flex xs5 lg3 text-left pl-0 pl-lg-3 pt-4 v-if="list.animalinvolved === 'YES'">
                  <span class="subheading" style="font-size: 16px;">
                    Preshoot Valid To

                  </span>
                  <br />
                  <span>{{ formatDate(list.validitytoDate) }}</span>
                </v-flex>
                <!--  <v-flex xs12 pa-5>
                  <v-card elevation="0" style="border: 1px solid black; border-radius: 0px">
                    <v-layout wrap justify-center>
                      <v-flex xs12>
                        <v-layout wrap class="subheading">
                          <v-flex xs2 text-center pt-2>
                            Location
                          </v-flex>
                          <v-flex xs2 text-center pt-2>
                            Film Name
                          </v-flex>
                          <v-flex xs1 text-center pt-2>
                            From Date
                          </v-flex>
                          <v-flex xs2 text-center pt-2>
                            To Date
                          </v-flex>
                          <v-flex xs2 text-center pt-2>
                            No Of Members
                          </v-flex>
                          <v-flex xs2 text-center pt-2>
                            No Of Vehicles
                          </v-flex>
                          <v-flex xs1 text-center pt-2>
                            No Of Days
                          </v-flex>

                        </v-layout>
                      </v-flex>
                      <v-flex xs12> </v-flex>
                    </v-layout>
                    <v-layout wrap pt-4 pb-4>
                      <v-flex xs12>
                        <v-divider></v-divider>
                      </v-flex>
                    </v-layout>
                    <v-layout pb-3 wrap v-for="(item, i) in filmShootingDetails" :key="i">
                      <v-flex xs2 text-center pt-2>
                        {{ item.location }}
                      </v-flex>
                      <v-flex xs2 text-center pt-2>
                        {{ item.filmName }}
                      </v-flex>
                      <v-flex xs1 text-center pt-2>
                        {{ formatDate(item.fromDate) }}
                      </v-flex>
                      <v-flex xs2 text-center pt-2>
                        {{ formatDate(item.toDate) }}
                      </v-flex>
                      <v-flex xs2 text-center pt-2>
                        {{ item.noOfMembers }}
                      </v-flex>
                      <v-flex xs2 text-center pt-2>
                        {{ item.noOfVehicles }}
                      </v-flex>
                      <v-flex xs1 text-center pt-2>
                        {{ item.shootingDuration }}
                      </v-flex>
                    </v-layout>
                  </v-card> 
                </v-flex>-->
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <!-- <v-layout>
          <v-flex xs12 pt-6>
                  <v-layout wrap justify-center>
                    
                    <v-flex xs2>
                      <v-btn block type="submit" class="text-capitalize" @click="
                        forwardToUsers(), (forwarddialog = true)
                        " color="red">
                        <v-icon color="white">mdi-share</v-icon>&nbsp;
                        <span style="color: white">FORWARD</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
        </v-layout> -->

        <v-layout wrap justify-center>

          <v-flex lg12 pt-5>
    <v-card>
      <v-layout wrap justify-start>
  <v-flex xs12 pl-3 pt-3 pb-4 class="bgcustom">
    <span style="font-size: 25px; color: white">Comments by Ministerial Head</span>
  </v-flex>

  <v-flex lg12 pa-4>
    <v-container fluid>
      <v-row>
        <v-layout wrap justify-center>
          <v-flex lg12 v-for="(reason, index) in ministirialRefusalReason" :key="index">
            <v-layout wrap justify-between align-center>
              <!-- Checkbox for the reason -->
              <v-flex lg9>
                <v-checkbox 
                  v-model="reason.isChecked" 
                  :label="reason.reason" 
                  color="primary" 
                  class="pa-0" 
                  hide-details="auto"
                  @change="updateSuggestions(index)"
                ></v-checkbox>
              </v-flex>
            </v-layout>

            <!-- Conditionally render the text field for details if checkbox is checked -->
            <v-flex lg12 v-if="reason.isChecked" pt-2>
              <!-- <span>Ministirial Suggestion</span> -->
              <v-text-field 
                v-model="reason.suggestion" 
                placeholder="Details of Offence" 
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </v-flex>
          </v-flex>
        </v-layout>

        <!-- Detailed Remarks Section -->
        <v-flex lg12 pt-3>
          <v-layout wrap justify-center>
            <v-flex lg12 pb-1>
              <span>Detailed Remarks</span>
            </v-flex>
          </v-layout>
          <v-textarea 
            v-model="detailedRemarks" 
            outlined 
            dense 
            rows="2"
            hide-details="auto"
          ></v-textarea>
        </v-flex>

        <!-- Submit and Forward Buttons -->
        <v-flex lg12 pt-6>
          <v-layout wrap justify-end>
            <v-flex lg4 class="text-end">
              <v-layout wrap justify-end>
                <v-flex lg5 class="text-end">
                  <v-btn color="success" @click="refusalreasonSubmit()">Save</v-btn>
                </v-flex>
                <v-flex lg5 v-if="forwardbtn" class="text-end">
                  <v-btn color="success" @click="forwardToUsers(), (forwarddialog = true)">Forward</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-row>
    </v-container>
  </v-flex>

</v-layout>

    </v-card>

  </v-flex>

  <v-flex lg12 pt-5 v-if="list.dfoSuggestions && list.dfoSuggestions.length > 0">
    <v-card>
      <v-layout wrap justify-start>
        <v-flex xs12 pl-3 pt-3 pb-4 style="background-color: #343434;">
          <span style="font-size: 25px; color: white">Comments by DFO</span>
        </v-flex>

        <v-flex lg12 pa-4>
          <v-container fluid>
            <v-row>
              <!-- Loop through reasonsForRefusal array -->
               <v-layout wrap justify-center>
              <v-flex lg12 v-for="(reason, index) in divisionRefusalReason" :key="index">
                <v-layout wrap justify-between align-center>
                  <!-- Checkbox for the reason -->
                  <!-- <v-flex lg9>
                    <v-checkbox 
                      v-model="reason.isChecked" 
                      :label="reason.reason" 
                      color="black" 
                      class="pa-0" 
                      readonly
                      hide-details="auto"
                    ></v-checkbox>
                  </v-flex> -->

                  <v-flex lg9 pb-1 v-if="reason.isChecked">
                    <span style="font-weight: 600">{{ reason.reason }}</span>
                  </v-flex>

                 
                </v-layout>

                <!-- Conditionally render the text field for details if checkbox is checked -->
                <v-flex lg12 pb-2 v-if="reason.details !== ''">
                  <span>{{ reason.details }}</span>
                  <!-- <v-text-field 
                    v-model="reason.details" 
                    placeholder="Details of Offence" 
                    outlined
                    dense
                    readonly 
                    hide-details="auto"
                  ></v-text-field> -->
                </v-flex>
               
              </v-flex>
            </v-layout>

              <!-- Detailed Remarks Section -->
              <v-flex lg12 pt-2>
                <v-layout wrap justify-center>
                    <v-flex lg12 pb-1>
                      <span style="font-weight: 600">Detailed Remarks</span>
                    </v-flex>
                    <v-flex lg12>
                      <span style="color: #36454F	;">{{ divisionRemarks }}</span>
                    </v-flex>
                  </v-layout>
                <!-- <v-textarea 
                  v-model="detailedRemarks" 
                  outlined 
                  dense 
                  readonly
                  rows="2"
                  hide-details="auto"
                ></v-textarea> -->
              </v-flex>

            </v-row>
          </v-container>
        </v-flex>
      </v-layout>
    </v-card>

    <!-- Delete Confirmation Dialog
    <v-dialog v-model="deleteDialogVisible" max-width="400px">
      <v-card>
        <v-card-title>Delete Reason</v-card-title>
        <v-card-text>Are you sure you want to delete this reason?</v-card-text>
        <v-card-actions>
          <v-btn color="red" text @click="deleteDialogVisible = false">Cancel</v-btn>
          <v-btn color="green" text @click="deleteReason">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-flex>

  <v-flex lg12 pt-5>
    <v-card>
      <v-layout wrap justify-start>
        <v-flex xs12 pl-3 pt-3 pb-4 style="background-color: #343434;">
          <span style="font-size: 25px; color: white">Comments by Clerk</span>
        </v-flex>

        <v-flex lg12 pa-4>
          <v-container fluid>
            <v-row>
              <!-- Loop through reasonsForRefusal array -->
               <v-layout wrap justify-center>
              <v-flex lg12 v-for="(reason, index) in clerkRefusalReason" :key="index">
                <v-layout wrap justify-between align-center>
                  <!-- Checkbox for the reason -->
                  <!-- <v-flex lg9>
                    <v-checkbox 
                      v-model="reason.isChecked" 
                      :label="reason.reason" 
                      color="black" 
                      class="pa-0" 
                      readonly
                      hide-details="auto"
                    ></v-checkbox>
                  </v-flex> -->

                  <v-flex lg9 pb-1 v-if="reason.isChecked">
                    <span style="font-weight: 600">{{ reason.reason }}</span>
                  </v-flex>

                 
                </v-layout>

                <!-- Conditionally render the text field for details if checkbox is checked -->
                <v-flex lg12 pb-2 v-if="reason.details !== ''">
                  <span style="color: #36454F;">{{ reason.details }}</span>
                  <!-- <v-text-field 
                    v-model="reason.details" 
                    placeholder="Details of Offence" 
                    outlined
                    dense
                    readonly 
                    hide-details="auto"
                  ></v-text-field> -->
                </v-flex>
               
              </v-flex>
            </v-layout>

              <!-- Detailed Remarks Section -->
              <v-flex lg12 pt-2>
                <v-layout wrap justify-center>
                    <v-flex lg12 pb-1>
                      <span style="font-weight: 600">Detailed Remarks</span>
                    </v-flex>

                    <v-flex lg12>
                      <span style="color: #36454F	;">{{ clerkRemarks }}</span>
                    </v-flex>
                  </v-layout>
                <!-- <v-textarea 
                  v-model="detailedRemarks" 
                  outlined 
                  dense 
                  readonly
                  rows="2"
                  hide-details="auto"
                ></v-textarea> -->
              </v-flex>

            </v-row>
          </v-container>
        </v-flex>
      </v-layout>
    </v-card>

    <!-- Delete Confirmation Dialog
    <v-dialog v-model="deleteDialogVisible" max-width="400px">
      <v-card>
        <v-card-title>Delete Reason</v-card-title>
        <v-card-text>Are you sure you want to delete this reason?</v-card-text>
        <v-card-actions>
          <v-btn color="red" text @click="deleteDialogVisible = false">Cancel</v-btn>
          <v-btn color="green" text @click="deleteReason">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-flex>

  

  

</v-layout>







        <!-- <v-layout wrap justify-center>
          <v-flex xs12 pt-16>
            <v-layout wrap justify-center>
              <v-flex xs3 v-if="list.paymentStatus !== 'Success'">
                <v-text-field label="Security Deposit" type="number" dense color="#283e51" outlined
                  background-color="white" v-model="list.securitydeposit" hide-details class="inputPrice">
                  <template v-slot:label>
                    <span class="custom-label-text" style="color: black; font-size: 14px">
                      Security Deposit
                      <span style="color: rgb(255, 0, 0)">*</span>
                    </span>
                  </template>
                </v-text-field> </v-flex>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <v-flex xs3 v-if="list.paymentStatus !== 'Success'">
                <v-text-field label="Film Shooting Fees" type="number" dense color="#283e51" outlined
                  background-color="white" v-model="list.shootingfee" hide-details class="inputPrice">
                  <template v-slot:label>
                    <span class="custom-label-text" style="color: black; font-size: 14px">
                      Film Shooting Fees
                      <span style="color: rgb(255, 0, 0)">*</span>
                    </span>
                  </template>
                </v-text-field>
              </v-flex>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <v-flex xs3 v-if="list.rangeMahassars && list.rangeMahassars.length > 0">
                <v-text-field label="Refund Amount" type="number" dense color="#283e51" outlined
                  background-color="white" v-model="list.refundAmount" hide-details class="inputPrice">
                  <template v-slot:label>
                    <span class="custom-label-text" style="color: black; font-size: 14px">
                      Refund Amount
                      <span style="color: rgb(255, 0, 0)">*</span>
                    </span>
                  </template>
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-center>
              <v-flex xs3 pt-6
                v-if="list.paymentStatus !== 'Success' || (list.rangeMahassars && list.rangeMahassars.length > 0)">
                <v-btn @click="submitfee()" color="green" block type="submit">
                  <span style="color: white">UPDATE</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 pt-6>
            <v-layout wrap justify-center>
              <v-flex xs2>
                <v-btn block type="submit" class="text-capitalize" @click="forwardToUsers(), (forwarddialog = true)"
                  color="red">
                  <v-icon color="white">mdi-share</v-icon>&nbsp;
                  <span style="color: white">FORWARD</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout> -->
        
        

        
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-layout wrap
          justify-center>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <v-flex xs2>
            <v-btn color="primary" @click="goBack">
              <span style="text-transform: none; font-size: 15px; color: white">
                GO BACK
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogVisible2" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="mainfont"> Upload Report </span>
        </v-card-title>
        <v-card-text>
          <v-card>
            <v-file-input class="mainfont" v-model="reportFile" label="Choose Report file"></v-file-input>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-btn class="mainfont" @click="uploadReport()" color="primary">Yes</v-btn>
          <v-btn @click="dialogVisible2 = false" color="error">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogVisible" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="mainfont"> Upload Magasar </span>
        </v-card-title>
        <v-card-text>
          <v-card>
            <v-file-input class="mainfont" v-model="mahasarFile" label="Choose Mahasar file"></v-file-input>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-btn class="mainfont" @click="uploadMahasar()" color="primary">Yes</v-btn>
          <v-btn @click="dialogVisible = false" color="error">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openDialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="mainfont"> Upload Agreement </span>
        </v-card-title>
        <v-card-text>
          <v-card> </v-card>
          <v-file-input class="mainfont" v-model="file" label="Choose a file"></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-btn class="mainfont" @click="uploadAgreement()" color="primary">Yes</v-btn>
          <v-btn @click="openDialog = false" color="error">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog :retain-focus="true" persistent v-model="deletedialog" max-width="600px">
      <v-card>
        <v-card-title class="mainfont" style="color: black; font-size: 18px; font-weight: lighter">Are you sure you want
          to Cancel?</v-card-title>
        <v-card-actions class="d-flex justify-center text-center">
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="deletedialog = false" class="mainfont">Cancel</v-btn>
          <v-btn color="red" class="mainfont" text @click="deleteItem()">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog :retain-focus="true" persistent v-model="forwarddialog" max-width="700px">
      <v-card>
        <v-layout wrap justify-center>
          <v-flex xs8 text-left pt-5>
            <span class="mainfont" style="color: black; font-size: 18px; font-weight: lighter">
              Are you sure you want to forward?
            </span>
          </v-flex>
          <v-flex xs8 pt-6 pr-4 class="mainfont">
            <v-autocomplete outlined dense color="black" :items="usernames" v-model="selectedUsername" item-text="name"
              placeholder="Select a Role" style="font-family: mainfont" item-value="name" item-color="#FF1313"
              hide-details clearable class="custom-autocomplete">
              <template v-slot:append>
                <v-icon color="black">mdi-chevron-down</v-icon>
              </template>
            </v-autocomplete>
          </v-flex>

          <v-flex xs8 pt-5 pr-4 class="mainfont">
            <v-text-field placeholder="Reason" v-model="reason" dense class="mainfont" outlined color="black">
            </v-text-field>
          </v-flex>
        </v-layout>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="forwarddialog = false" class="mainfont">Cancel</v-btn>
          <v-btn color="red" class="mainfont" text @click="forwardToUsers2()" :disabled="forwardInProgress">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
// import CryptoJS from "crypto-js";
export default {
  components: {},
  data() {
  const today = new Date().toISOString().substr(0, 10);
  return {
    dialogVisible2: false,
    shootingfee: null,
    refundAmount: null,
    securitydeposit: null,
    idNo: null,
    forwarddialog: false,
    forwardInProgress: false,
    startDate: today,
    showSnackBar: false,
    isChecked: false,
    deletedialog: false,
    openDialog: false,
    reportFile: null,
    file: null,
    mahasarFile: null,
    appLoading: false,
    msg: "",
    id: this.$route.query.id || '', // Ensure `id` is always initialized
    name: null,
    dialogVisible: false,
    barlist: [],
    list: {},
    leaderdetails: [],
    idProof: "",
    Preshootfile: "",
    filmShootingDetails: [],
    usernames: [],
    selectedUsername: null,
    reason: null,
    onAccount: false,
    onAccountremarks: '',
    isConvicted: false,
    offenceDetails: '',
    isAccused: false,
    accusedOffenceDetails: '',
    clerkRefusalReason: [
        { reason: "On account of the position of the Depot.", isChecked: false, details: '', showSuggestion: false, suggestion: '' },
        { reason: "Whether convicted in any forest/Wildlife offences?", isChecked: false, details: '', showSuggestion: false, suggestion: '' },
        { reason: "Whether accused in any forest/Wildlife offences?", isChecked: false, details: '', showSuggestion: false, suggestion: '' }
      ],

      divisionRefusalReason: [
        { reason: "On account of the position of the Depot.", isChecked: false, details: '', showSuggestion: false, suggestion: '' },
        { reason: "Whether convicted in any forest/Wildlife offences?", isChecked: false, details: '', showSuggestion: false, suggestion: '' },
        { reason: "Whether accused in any forest/Wildlife offences?", isChecked: false, details: '', showSuggestion: false, suggestion: '' }
      ],

      ministirialRefusalReason: [
        { reason: "On account of the position of the Depot.", isChecked: false, details: '', showSuggestion: false, suggestion: '' },
        { reason: "Whether convicted in any forest/Wildlife offences?", isChecked: false, details: '', showSuggestion: false, suggestion: '' },
        { reason: "Whether accused in any forest/Wildlife offences?", isChecked: false, details: '', showSuggestion: false, suggestion: '' }
      ],
      detailedRemarks: '',
      ministerialSuggestions: [
      { suggestion: '', details: '' } // Start with one object in the array
    ],
      forwardbtn: false,
      deleteDialogVisible: false,
      deleteIndex: null,
      clerkRemarks: "",
      divisionRemarks: "",

    ServerError: false
  };
},

  mounted() {
    this.getList();
  },
  created() {
    this.uType = localStorage.getItem("uType");
  },

  computed: {
    user() {
      const uType = localStorage.getItem("uType");
      if (uType === "777") {
        return "admin";
      } else if (uType === "772") {
        return "user";
      } else if (uType === "773") {
        return "range";
      } else if (uType === "7741") {
        return "section";
      } else if (uType === "7742") {
        return "superclerk";
      } else {
        return "division";
      }
    },
  },

  methods: {
    //   navigateToRecords(id) {
    //   const encryptedId = CryptoJS.AES.encrypt(id.toString(), 'encryptionSecret').toString();
    //   this.$router.push({
    //     path: '/records',
    //     query: {
    //       id: encryptedId
    //     }
    //   });
    // },

    updateSuggestions(index) {
      // Reset suggestion field when checkbox is unchecked
      if (!this.ministirialRefusalReason[index].isChecked) {
        this.ministirialRefusalReason[index].suggestion = '';
      }
    },



    toggleSuggestion(index) {
    this.reasonsForRefusal[index].showSuggestion = !this.reasonsForRefusal[index].showSuggestion;
  },
  
  // Show confirmation dialog for deleting a reason
  confirmDeleteReason(index) {
    this.deleteIndex = index;
    this.deleteDialogVisible = true;
  },

  // Delete the reason after confirmation
  deleteReason() {
    if (this.deleteIndex !== null) {
      this.reasonsForRefusal.splice(this.deleteIndex, 1);
      this.deleteDialogVisible = false;
      this.deleteIndex = null;
    }
  },

  // addMinisterialSuggestion() {
  //   this.ministerialSuggestions.push({ suggestion: '', details: '' });
  // },
  // removeMinisterialSuggestion(index) {
  //   this.ministerialSuggestions.splice(index, 1);
  // },

  // Handle form submission, passing separate arrays for refusal reasons and ministerial suggestions
  refusalreasonSubmit() {
  // Filter to get only the checked reasons
  const checkedReasons = this.ministirialRefusalReason.filter(reason => reason.isChecked);

  // Construct ministerialSuggestions array based on checked reasons
  const ministerialSuggestions = checkedReasons
    .filter(reason => reason.suggestion)  // Only include reasons with suggestions
    .map(reason => ({
      suggestion: reason.reason,  // Set suggestion to refusal reason
      details: reason.suggestion  // Set details to entered suggestion
    }));

  // Make API request
  axios({
    url: "/ministerialadd/refusalreason/remarks",
    method: "POST",
    headers: {
      token: localStorage.getItem("token"),
    },
    data: {
      appid: this.id,
      // reasonsForRefusal: checkedReasons,  // Only pass checked reasons
      detailedRemarks: this.detailedRemarks,  // Detailed remarks
      ministerialSuggestions: ministerialSuggestions  // Transformed ministerial suggestions
    },
  })
  .then((response) => {
    if (response.data.status) {
      this.msg = response.data.msg;
      this.showSnackBar = true;
      this.forwardbtn = true;
    } else {
      this.msg = response.data.msg;
      this.showSnackBar = true;
    }
  })
  .catch((err) => {
    console.error(err);
  });
},



    goBack() {
      // Use the router to navigate back to the previous page
      this.$router.go(-1);
    },
    forwardToUsers(id) {
      this.getUsers(id);
      this.appids = id;
    },
    // forwardToUsers2() {
    //   this.forward();
    // },
    forwardToUsers2() {
      if (this.forwardInProgress) return; // Don't proceed if forwarding is already in progress
      this.forwardInProgress = true; // Set flag to indicate forwarding is in progress
      this.forward();
    },
    forward() {
      if (!this.selectedUsername) {
        // this.$refs.snackbar.showSnackbar("Please select a user to forward to.");
        this.msg = ("Please select a user to forward to.");
        this.showSnackBar = true;
        this.forwardInProgress = false;
        return;
      }
      if (!this.reason) {
        // this.$refs.snackbar.showSnackbar("Please select a user to forward to.");
        this.msg = ("Reason not provided.");
        this.showSnackBar = true;
        this.forwardInProgress = false;
        return;
      }
      const selectedUser = this.usernames.find(
        (user) => user.name === this.selectedUsername
      );
      if (!selectedUser) {
        return;
      }

      axios({
        method: "post",
        url: "/application/forward",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          appid: this.id,
          forwardto: selectedUser.userId,
          reason: this.reason,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            alert(response.data.msg);
            this.msg = response.data.msg;
            this.showSnackBar = true;
            // window.location.reload();
            this.$router.push({ path: "/superintedent" });
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.error(err);
        });
    },
    getUsers() {
      axios({
        method: "GET",
        url: "/ministerialhead/forward/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          appid: this.id,
        },
      })
      .then((response) => {
    // Log the full response for inspection
    console.log("Full Response:", response);

    // Access the data array within the response object
    const usersArray = response.data.data;

    // Check if usersArray is indeed an array
    if (Array.isArray(usersArray)) {
      this.usernames = usersArray.map(user => {
        console.log("User:", user); // Log each user object for clarity
        return {
          name: `${user.username} (DFO)`, // Adjust role based on your logic
          role: "DFO", // Static role for now, can be dynamic
          userId: user._id,
        };
      });
    } else {
      console.error("Expected an array but got something else:", usersArray);
    }

    // Log the final usernames array
    console.log("Usernames Array:", this.usernames);
  })
  .catch((err) => {
    this.ServerError = true;
    console.error("Error:", err);
  });
},
    forwardToClerk2() {
      axios({
        url: "/range/forward/clerk",
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          appid: this.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.deletedialog = false;
            // window.location.reload();
            this.$router.push({ path: "/rangebookings" });
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },
    uploadAgreement() {
      const formData = new FormData();
      formData.append("userAgreement", this.file);
      formData.append("appid", this.id);
      axios
        .post(`/user/agreement`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          console.log(response.data);
          this.openDialog = false;
          location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
    },

    uploadReport() {
      const formData = new FormData();
      formData.append("rangeReport", this.reportFile);
      formData.append("appid", this.id);
      axios
        .post(`/report/upload`, formData, {
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response.data);
          (this.dialogVisible = false), location.reload();
        })
        .catch((error) => {
          // Handle error
          console.error(error);
        });
    },
    uploadMahasar() {
      const formData = new FormData();
      formData.append("rangeMahassar", this.mahasarFile);
      formData.append("appid", this.id);
      axios
        .post(`/mahassar/upload`, formData, {
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response.data);
          (this.dialogVisible = false), location.reload();
        })
        .catch((error) => {
          // Handle error
          console.error(error);
        });
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const selectedFile = event.target.files[0];
      console.log("Selected file:", selectedFile);
    },
    forwardToClerk() {
      axios({
        url: "/check/forward",
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          appid: this.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            window.location.reload();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    feePayment() {
      axios({
        url: "/fees/submission",
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          appid: this.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.forwardToClerk();
            // this.deletedialog = false;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteItem() {
      axios({
        url: "/cancel/application",
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          appid: this.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.deletedialog = false;
            window.location.reload();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getAcknowledgment() {
      const token = localStorage.getItem("token");
      const downloadUrl = "/acknowledgement/pdf";
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          appid: this.id,
        },
        responseType: "blob",
      };

      axios
        .get(downloadUrl, config)
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);

          // Open the URL in a new tab
          const newTab = window.open();
          newTab.document.write(
            '<iframe width="100%" height="100%" src="' +
            url +
            '" type="application/pdf"></iframe>'
          );
          newTab.document.close();
        })
        .catch((error) => {
          console.error("Error downloading acknowledgement:", error);
        });
    },
    getApplication() {
      const token = localStorage.getItem("token");
      const downloadUrl = "/application/pdf";
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          appid: this.id,
        },
        responseType: "blob",
      };

      axios
        .get(downloadUrl, config)
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);

          // Open the URL in a new tab
          const newTab = window.open();
          newTab.document.write(
            '<iframe width="100%" height="100%" src="' +
            url +
            '" type="application/pdf"></iframe>'
          );
          newTab.document.close();
        })
        .catch((error) => {
          console.error("Error downloading acknowledgement:", error);
        });
    },

    getAgreement() {
      const token = localStorage.getItem("token");
      const downloadUrl = "/agreement/pdf";
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          appid: this.id,
        },
        responseType: "blob",
      };

      axios
        .get(downloadUrl, config)
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);

          // Open the URL in a new tab
          const newTab = window.open();
          newTab.document.write(
            '<iframe width="100%" height="100%" src="' +
            url +
            '" type="application/pdf"></iframe>'
          );
          newTab.document.close();
        })
        .catch((error) => {
          console.error("Error downloading acknowledgement:", error);
        });
    },
    submitfee() {
      axios({
        url: "/addSecurityDepositAndShootingFee",
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          appid: this.id,
          securitydeposit: this.list.securitydeposit,
          shootingfee: this.list.shootingfee,
          refundAmount: this.list.refundAmount,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.msg = response.data.msg;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            window.location.reload();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    // getAgreement() {
    //   const token = localStorage.getItem("token");
    //   const downloadUrl = "/agreement/pdf";
    //   const config = {
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //     },
    //     params: {
    //       appid: this.id,
    //     },
    //     responseType: "blob",
    //   };

    //   axios
    //     .get(downloadUrl, config)
    //     .then((response) => {
    //       const blob = new Blob([response.data], { type: 'application/pdf' });
    //       const url = window.URL.createObjectURL(blob);

    //       // Set the window location to the PDF URL
    //       window.location.href = url;
    //     })
    //     .catch((error) => {
    //       console.error("Error downloading acknowledgement:", error);
    //     });
    // },

    // getList() {
    //   this.appLoading = true;
    //   axios({
    //     method: "POST",
    //     url: "/single/application",
    //     headers: {
    //       token: localStorage.getItem("token"),
    //     },
    //     data: {
    //       appid: this.id,
    //     },
    //   })
    //     .then((response) => {
    //       if (response.data.status == true) {
    //         this.list = response.data.data;
    //         this.filmShootingDetails = this.list.filmShootingDetails;
    //         this.memberDetails = this.list.memberDetails;
    //         this.idProof = this.list.idProof;
    //         this.Preshootfile = this.list.Preshootfile;
    //         this.reqLetter = this.list.reqLetter;
    //         this.participantfile = this.list.participantfile;
    //         this.leaderIdProof = this.list.leaderIdProof;
    //         this.appLoading = false;
    //       } else {
    //         this.msg = response.data.msg;
    //         this.showSnackBar = true;
    //         this.appLoading = false;
    //       }
    //     })
    //     .catch((err) => {
    //       this.ServerError = true;
    //       console.error(err);
    //     });
    // },

    getList() {
  this.appLoading = true;
  axios({
    method: "POST",
    url: "/single/application",
    headers: {
      token: localStorage.getItem("token"),
    },
    data: {
      appid: this.id,
    },
  })
    .then((response) => {
      if (response.data.status === true) {
        this.list = response.data.data;
        const backendReasons = this.list.reasonsForRefusal || [];
        const backendDFOSuggestions = this.list.dfoSuggestions || [];
        const backendMinisterialSuggestions = this.list.ministerialSuggestions || [];

        // Map Clerk Refusal Reasons
        this.clerkRefusalReason = this.clerkRefusalReason.map((localReason) => {
          const foundReason = backendReasons.find(item => item.reason === localReason.reason);
          return {
            ...localReason,
            isChecked: !!foundReason,
            details: foundReason ? foundReason.details : '',
          };
        });

        // Map Division Refusal Reasons
        this.divisionRefusalReason = this.divisionRefusalReason.map((localReason) => {
          const foundSuggestion = backendDFOSuggestions.find(item => item.suggestion === localReason.reason);
          return {
            ...localReason,
            isChecked: !!foundSuggestion,
            details: foundSuggestion ? foundSuggestion.details : '',
          };
        });

        // Map Ministerial Refusal Reasons
        this.ministirialRefusalReason = this.ministirialRefusalReason.map((localReason) => {
          const foundSuggestion = backendMinisterialSuggestions.find(item => item.suggestion === localReason.reason);
          return {
            ...localReason,
            isChecked: !!foundSuggestion,
            suggestion: foundSuggestion ? foundSuggestion.details : '',
          };
        });

        // Update detailed remarks
        this.clerkRemarks = this.list.clerkRemarks || '';
        this.divisionRemarks = this.list.divisionRemarks || '';
        this.detailedRemarks = this.list.ministerialRemarks || '';
        // this.detailedRemarks = this.list.clerkRemarks || '';
      } else {
        this.msg = response.data.msg;
        this.showSnackBar = true;
      }
      this.appLoading = false;
    })
    .catch((err) => {
      this.ServerError = true;
      console.error(err);
      this.appLoading = false;
    });
},








// getList() {
//   this.appLoading = true;
//   axios({
//     method: "POST",
//     url: "/single/application",
//     headers: {
//       token: localStorage.getItem("token"),
//     },
//     data: {
//       appid: this.id,
//     },
//   })
//     .then((response) => {
//       if (response.data.status === true) {
//         this.list = response.data.data;
//         this.filmShootingDetails = this.list.filmShootingDetails;
//         this.memberDetails = this.list.memberDetails;
//         this.idProof = this.list.idProof;
//         this.Preshootfile = this.list.Preshootfile;
//         this.reqLetter = this.list.reqLetter;
//         this.participantfile = this.list.participantfile;
//         this.leaderIdProof = this.list.leaderIdProof;
//         this.securitydeposit = this.list.securitydeposit;
//         this.shootingfee = this.list.shootingfee;
//         this.refundAmount = this.list.refundAmount;

//         // Map reasonsForRefusal from the backend to your component's reasonsForRefusal array
//         const backendReasons = this.list.reasonsForRefusal || [];

//         // Loop through your local reasonsForRefusal array and update based on backend response
//         this.reasonsForRefusal.forEach((localReason) => {
//           const foundReason = backendReasons.find(item => item.reason === localReason.reason);

//           if (foundReason) {
//             // Update local reason if found in backend data
//             localReason.isChecked = foundReason.isChecked || false;  // Use the isChecked value from the backend
//             localReason.details = foundReason.details || '';
//           } else {
//             // Ensure that reasons not found in backend are unchecked
//             localReason.isChecked = false;
//             localReason.details = '';
//           }
//         });

//         // Set other fields
//         this.detailedRemarks = this.list.detailedRemarks || '';
//         this.appLoading = false;
//       } else {
//         this.msg = response.data.msg;
//         this.showSnackBar = true;
//         this.appLoading = false;
//       }
//     })
//     .catch((err) => {
//       this.ServerError = true;
//       console.error(err);
//     });
// },


  },
};
</script>


<style>
.subheading {
  font-family: mainfont;
  color: #42275a;
  text-transform: none;
  font-size: 17px;
  font-weight: bold;
}

.heading {
  font-family: mainfont;
  color: white;
  text-transform: none;
  font-size: 22px;
}

.no-spinners {
  /* Remove the up and down arrows */
  appearance: textfield;
  -moz-appearance: textfield;
  -webkit-appearance: textfield;
}

.inputPrice input::-webkit-outer-spin-button,
.inputPrice input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>